import {useFormContext} from "react-hook-form";
import {StyledError, StyledInfoMessage, StyledTxtField,} from "../styles/styledComponents";
import MountingTypeField from "../types/MountingTypeField";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import colors from "../styles/colors";
import ReactMarkdown from 'react-markdown';
type FieldProps = {
  field: MountingTypeField;
};

const Field = (props: FieldProps) => {
  const { field } = props;
  const { t } = useTranslation("trans");

  const {
    register,
    formState: { errors },
  } = useFormContext();
  
    const validateInput = (event: any) => {
        event.target.value = event.target.value.trim();
    };

    const fieldType = field.type?.toLowerCase();
    const isFloat = fieldType === "float";

    // "float" is not a valid input type, so the browser silently falls back to
    // text anyway. Say so explicitly and ask for the decimal keypad instead of
    // using type="number": a number input rejects the comma outright in locales
    // that use a period, which would blank the field for a Norwegian user on an
    // English browser. onSubmit normalises the separator before sending.
    const inputType = fieldType === "int" ? "number" : isFloat ? "text" : field.type;

    // Accept both separators (and an empty field) unless the field data brings
    // its own pattern.
    const decimalPattern = /^[0-9]*([.,][0-9]+)?$/;

  return (
      <StyledTxtField
          onChange={validateInput}
      >
          <label htmlFor={field.id.toString()}><ReactMarkdown>{field.label!}</ReactMarkdown>       
      </label>
         
      <div style={{display: 'inline-flex', alignItems: 'center'}}>
      <input
        aria-describedby={
          errors[field.id.toString()]?.message
            ? field.name + "-error " + field.name + "-info"
            : field.name + "-info"
        }
        className={errors[field.id.toString()]?.message ? "Error" : ""}
        id={field.id.toString()}
        placeholder={field.placeholder}
                  autoFocus={false}
                
        type={inputType}
        inputMode={isFloat ? "decimal" : undefined}
        defaultValue={field.defaultValue}
        {...register(field.id.toString(), {
          required: field.required ? t("field.required").toString() : undefined,
          min: field.minimumValue
            ? {
                value: field.minimumValue,
                message: t("field.minValue").toString() + field.minimumValue,
              }
            : undefined,
          max: field.maximumValue
            ? {
                value: field.maximumValue,
                message: t("field.maxValue").toString() + field.maximumValue,
              }
                : undefined,  
          pattern: field.regexPattern
            ? {
                 value: new RegExp(field.regexPattern),
                 message: t("field.invalidPattern").toString(),
              }
            : isFloat
            ? {
                 value: decimalPattern,
                 message: t("field.invalidPattern").toString(),
              }
               : undefined,
        })}
      />
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        size="lg"
        color={colors.ErrorBorder}
        style={{
          marginLeft: '-40px',
          display: errors[field.id.toString()]?.message ? "block" : "none",
        }}
      />
      </div>
      <StyledInfoMessage id={field.name + "-info"}>
        {field.description}
      </StyledInfoMessage>
      <StyledError id={field.name + "-error"} role="alert" aria-atomic="true">
        {errors[field.id.toString()]?.message}
      </StyledError>
    </StyledTxtField>
  );
};

export default Field;
